import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, errorMessage } from "../lib/api";
import { useAuth, homeFor } from "../lib/auth";
import { useLang } from "../lib/i18n";
import { OtpForm } from "../components/OtpForm";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [challenge, setChallenge] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.search);
    const expected = sessionStorage.getItem("oauth_state");
    sessionStorage.removeItem("oauth_state");
    if (params.get("error") || !params.get("code") || !expected || params.get("state") !== expected) {
      setError("Sign-in was cancelled or could not be verified.");
      return;
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    api.post("/auth/google", { code: params.get("code"), redirect_uri: window.location.origin + "/auth/google" })
      .then(({ data }) => {
        if (data.otp_required) return setChallenge(data.challenge_id);
        setUser(data); navigate(homeFor(data), { replace: true });
      })
      .catch((err) => setError(errorMessage(err, "Sign-in failed.")));
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-alabaster px-6">
      {challenge ? (
        <div className="w-full max-w-sm"><OtpForm challengeId={challenge} onBack={() => navigate("/login")} /></div>
      ) : error ? (
        <div className="max-w-sm text-center" data-testid="auth-callback-error">
          <p className="font-display text-xl font-bold text-slate-900">{t(error)}</p>
          <Link to="/login" className="mt-6 inline-block rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white" data-testid="auth-callback-back">{t("Back to sign in")}</Link>
        </div>
      ) : (
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-slate-900" data-testid="auth-callback-loading" />
      )}
    </div>
  );
}
